import { Injectable, Renderer2 } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarToggleService {

  public tooglePin: boolean = false;
  constructor() { }

  toggleMenu(menubar: boolean = false, outsideCheck: boolean = false) {
    const className = 'sidebar-enable';
    const divId = 'custom-backdrop';
    const docBody = document.body;
    const containCheck = document.documentElement.classList.contains(className);
    if (!menubar && outsideCheck && containCheck) {
      return;
    }
    if (!containCheck) {
      const div = document.createElement('div');
      div.id = divId;
      div.classList.add("offcanvas-backdrop", "fade", "show");
      docBody.style.overflow = 'hidden';
      docBody.style.paddingRight = '15px';
      docBody.appendChild(div);
    } else {
      const div = document.getElementById(divId);
      if (div) {
        docBody.removeChild(div);
      }
      docBody.style.removeProperty('overflow');
      docBody.style.removeProperty('padding-right');
    }
    document.documentElement.classList.toggle(className);
  }

  toogleSideBarPin() {
    this.tooglePin = !this.tooglePin;
    const attrVal = 'condensed', attr = 'data-sidenav-size';
    if (this.tooglePin) {
      this.toggleMenu();
      document.documentElement.setAttribute(attr, attrVal)
    } else {
      document.documentElement.setAttribute(attr, 'full')
    }
  }
}
